import "@hotwired/turbo-rails";
import { get } from "@rails/request.js";
import moment from "moment";
import "moment/dist/locale/fr.js";
import debounce from "lodash/debounce";

import jQuery from "jquery";
import { Toast } from "bootstrap";

import { DateRangePicker } from "./components/daterangepicker.js";

import "@videojs/html/media/hlsjs-video";

import Chartkick from "chartkick"
import Highcharts from "highcharts";

window.Highcharts = Highcharts;

Chartkick.use(Highcharts);
Chartkick.configure({ language: "fr", mapsApiKey: "AIzaSyDLBu0EtUYdVwDCH2Y13z7DNeCw5nZm9bI" })

const $ = jQuery;
moment.locale('fr');

const setupAnalytics = async () => {
    if (!document.querySelector("#loads_count_container")) {
        return;
    }

    const url = new URL("analytics/numbers", location.href);
    url.searchParams.set("start", window.date_start);
    url.searchParams.set("end", window.date_end);

    try {
        const response = await get(url);

        if (response.ok) {
            const json = await response.json;

            document.querySelector("#loads_count_container").innerHTML = json.loads;
            document.querySelector("#plays_count_container").innerHTML = json.plays;
            document.querySelector("#ratios_count_container").innerHTML = json.ratios;
        } else {
            const toast = new Toast(document.getElementById("toast-network-error"), { autohide: false });
            toast.show();
        }
    } catch (e) {
        console.error(e);
        const toast = new Toast(document.getElementById("toast-network-error"), { autohide: false });
        toast.show();
    }

    const player = document.querySelector("#chart-video");

    player.source = {
        src: window.src,
        type: "application/vnd.apple.mpegurl",
        maxAutoResolution: "360p",
        capRenditionToPlayerSize: false,
    };

    const updatePlayerOnHover = debounce(function () {
        if (player.paused) {
            player.currentTime = this.x / 100 * player.duration;
        }
    }, 100);

    const engagementChart = Chartkick.charts["engagement-chart"];
    const options = engagementChart.getOptions();
    engagementChart.setOptions({
        ...options,
        library: {
            ...options.library,
            chart: {
                backgroundColor: "transparent",
                plotBackgroundColor: "rgba(0, 0, 0, 0.5)",
                events: {
                    click: () => {
                        if (player.paused) {
                            player.play();
                        } else {
                            player.pause();
                        }
                    }
                }
            },
            tooltip: {
                formatter: function () {
                    const duration = moment().startOf('day')
                        .seconds(this.x / 100 * player.duration)
                        .format('H:mm:ss');

                    return `Engagement à <b>${duration}</b>: <b>${this.y} %</b>`;
                }
            },
            plotOptions: { series: { enableMouseTracking: true, point: { events: { mouseOver: updatePlayerOnHover } } } }
        }
    });

    // When the player is running, don't do anything on hover.
    player.addEventListener("play", () => {
        const { chart } = engagementChart;
        chart.series[0].update({ enableMouseTracking: false });
    });

    // When the player is paused again, allow hover.
    player.addEventListener("pause", () => {
        const { chart } = engagementChart;
        chart.series[0].update({ enableMouseTracking: true });
    });

    // Update the hover state when the player is playing.
    player.addEventListener("timeupdate", () => {
        if (!player.paused) {
            const { chart } = engagementChart;
            const index = Math.ceil(player.currentTime * 100 / player.duration);
            const point = chart.series[0].points[index];
            point.onMouseOver();
            chart.tooltip.refresh(point);
        }
    });
}

const setupDatePicker = () => {
    if (!document.querySelector("#report-range")) {
        return;
    }

    const url = new URL(location.href);

    const start = moment(window.date_start);
    const end = moment(window.date_end);

    function cb(start, end, label, initial = false) {
        if (!initial) {
            url.searchParams.set("start", start.format("YYYY-MM-DD"));
            url.searchParams.set("end", end.format("YYYY-MM-DD"));
            Turbo.visit(url);
            return;
        }

        let html = start.format('D MMMM YYYY') + ' - ' + end.format('D MMMM YYYY');
        if (start.isSame(end, 'day')) {
            html = start.format('D MMMM YYYY');
        }

        $('#report-range #report-range-label').html(html);
    }

    new DateRangePicker($('#report-range'), {
        startDate: start,
        endDate: end,
        ranges: {
            'Aujourd\'hui': [moment(), moment()],
            'Hier': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            '7 derniers jours': [moment().subtract(6, 'days'), moment()],
            '30 derniers jours': [moment().subtract(29, 'days'), moment()],
            'Ce mois-ci': [moment().startOf('month'), moment().endOf('month')],
            'Mois dernier': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        },
        locale: {
            format: "D MMMM YYYY",
            applyLabel: "Appliquer",
            cancelLabel: "Annuler",
            fromLabel: "De",
            toLabel: "À",
            customRangeLabel: 'Personnaliser',
        }
    }, cb);

    cb(start, end, "", true);
};

export { setupAnalytics, setupDatePicker }
